import { render, staticRenderFns } from "./cardTitle.vue?vue&type=template&id=7157b56d&"
import script from "./cardTitle.vue?vue&type=script&lang=js&"
export * from "./cardTitle.vue?vue&type=script&lang=js&"
import style0 from "./cardTitle.vue?vue&type=style&index=0&id=7157b56d&prod&soped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports